export default __webpack_public_path__ + "static/media/dummyimg.8ec2c6dd.jpg";